import axios from "axios";

export function sendEmailToUser(besafe_object_id) {
  return axios.get(`windows_clients/email_windows_installer?besafe_object_id=${besafe_object_id}`);
}

export function createWindowsExe() {
  return axios.post('windows_clients/build_windows_installer');
}

export function regenerateApiKey(user_id) {
  return axios.patch(`/besafe_objects/${user_id}/regenerate_api_key`);
}

export function updateAutoMode(user_id, is_auto_mode_enabled) {
  return axios.patch(`/besafe_objects/${user_id}/update_auto_mode`, { is_auto_mode_enabled });
}

export function resetTwoFactorAuth(user_id) {
  return axios.patch(`/besafe_objects/${user_id}/reset_two_factor_auth`);
}

export function updateTwoFactorAuthEnabled(user_id, enabled) {
  return axios.patch(`/besafe_objects/${user_id}/update_two_factor_auth_enabled`, {
    two_factor_auth_enabled: enabled
  });
}

export function updateArgusScanningEnabled(user_id, is_argus_scanning_enabled) {
  return axios.patch(`/besafe_objects/${user_id}/update_argus_scanning_enabled`, { is_argus_scanning_enabled });
}

export function updateArgusMode(user_id, argus_mode) {
  return axios.patch(`/besafe_objects/${user_id}/update_argus_mode`, { argus_mode });
}

export function updateArgusServiceEnabled(user_id, enable_argus_service) {
  return axios.patch(`/besafe_objects/${user_id}/update_argus_service_enabled`, { enable_argus_service });
}

export function updateNetworkSla(user_id, network_sla) {
  return axios.patch(`/besafe_objects/${user_id}/update_network_sla`, { network_sla });
}

export function updateNetworkSlaCollectorConfig(user_id, params) {
  return axios.patch(`/besafe_objects/${user_id}/update_network_sla_collector_config`, params);
}

export function updateNetflowConfig(user_id, params) {
  return axios.patch(`/besafe_objects/${user_id}/update_netflow_config`, params);
}

export function updateArgusCollectorConfig(user_id, params) {
  return axios.patch(`/besafe_objects/${user_id}/update_argus_collector_config`, params);
}
